import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=63fbe24a&scoped=true&"
import script from "./Links.vue?vue&type=script&lang=ts&"
export * from "./Links.vue?vue&type=script&lang=ts&"
import style0 from "./Links.vue?vue&type=style&index=0&id=63fbe24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbe24a",
  null
  
)

export default component.exports